import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

export default function QuizPage() {
  return (
    <main data-testid="quiz-page">
      <section className="pt-32 pb-20 md:pb-28 bg-[#1C1210] min-h-screen">
        <div className="max-w-4xl mx-auto px-6 md:px-12 lg:px-24">
          <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="text-center py-16">
            <span className="font-eyebrow text-[#D4A0A0] mb-6 block">BRAND QUIZ</span>
            <h1 className="mb-6">
              <span className="font-display text-4xl md:text-5xl text-white block">FIND OUT WHERE</span>
              <span className="font-display text-4xl md:text-5xl text-white block">YOUR BRAND IS</span>
              <span className="font-accent text-4xl md:text-5xl text-[#D4A0A0] block mt-2">stuck.</span>
            </h1>
            <p className="font-body text-base md:text-lg text-white/50 leading-relaxed max-w-lg mx-auto mb-8">
              A short quiz that helps you understand what kind of brand you're building and where the biggest gap is right now. Takes about 3 minutes.
            </p>
            <p className="font-serif text-xl text-white/70 mb-8">Coming soon.</p>
            <p className="font-body text-sm text-white/40 max-w-md mx-auto">
              Want to know when it's ready? Leave your email and I'll send you a note the moment it goes live.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto mt-6">
              <input type="email" placeholder="Your email" className="flex-1 font-body text-sm border border-white/20 rounded-full px-5 py-3 bg-white/5 text-white placeholder-white/30 focus:outline-none focus:border-[#D4A0A0] transition-colors duration-300" />
              <button className="inline-flex items-center justify-center gap-2 bg-[#BE123C] text-white font-body font-medium text-xs tracking-[2px] uppercase px-6 py-3 rounded-full hover:bg-[#9F1239] transition-colors duration-300">
                NOTIFY ME <ArrowUpRight size={14} />
              </button>
            </div>
          </motion.div>
        </div>
      </section>
    </main>
  );
}
